import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Header from './Header'
import Sidebar from './Sidebar'
import '../../assets/scss/components/Layout.scss'

const VerticalLayout = ({ children }) => {
  const isMobile = () => window.innerWidth <= 991
  const [isOpen, setIsOpen] = useState(!isMobile())

  // Auto-close on resize to mobile, auto-open on resize to desktop
  useEffect(() => {
    const handleResize = () => {
      if (isMobile()) {
        setIsOpen(false)
      } else {
        setIsOpen(true)
      }
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const toggleSidebar = () => setIsOpen(prev => !prev)

  const closeSidebar = () => {
    if (isMobile()) setIsOpen(false)
  }

  return (
    <div className="app-layout">
      {/* backdrop for mobile */}
      {isOpen && isMobile() && (
        <div className="sidebar-backdrop" onClick={closeSidebar} />
      )}
      <Sidebar isOpen={isOpen} onClose={closeSidebar} />
      <div className={`layout-main ${!isOpen ? 'sidebar-closed' : ''}`}>
        <Header toggleSidebar={toggleSidebar} />
        <main className="main-content">{children}</main>
      </div>
    </div>
  )
}

VerticalLayout.propTypes = {
  children: PropTypes.node,
}

export default VerticalLayout
